import { gql } from "@apollo/client";

export const GET_INDICACION_HISTORIAL = gql`
  query getIndicacionHistorial($input: IndicacionHistorialInput!) {
    indicacionHistorial(input: $input) {
      success
      error
      valorEsperado {
        idEvaluacion
        idIndicacion
        fechaDesde
        fechaHasta
        insumo
        cantidad
        idUnidad
        unidad
      }
    }
  }
`;